<template>
  <div :class="['v-overview', `v-overview--${appSlug}`]">
    <components :is="currentComponent" />
  </div>
</template>

<script>
import { computed } from '@vue/composition-api'
import { docTitleHandler } from '@/services/title'

const DEFAULT_OVERVIEW = 'OverviewDefault'

export default {
  name: 'Overview',

  setup(props, ctx) {
    const appSlug = computed(() => ctx.root.$store.getters['appConfig/getAppSlug'])
    const appLayoutOverview = computed(() => ctx.root.$store.getters['appConfig/getAppLayoutOverview'] || DEFAULT_OVERVIEW)
    const currentComponent = () => import(`./layouts/${appLayoutOverview.value}`)

    // Visiting overview resets title to appName
    docTitleHandler()

    return {
      appSlug,
      appLayoutOverview,
      currentComponent
    }
  }
}
</script>
